import { Input } from '@latitude/input';
import { cn } from '@latitude/token-utils';
import type { ChangeEvent } from 'react';

import { SpinnerButtons } from './SpinnerButtons';
import type { TimeSpinnerProps } from './types';
import { padWithZero } from './utils';

export const TimeSpinner = ({
  value,
  onChange,
  onBlur,
  onIncrement,
  onDecrement,
  rowHeight,
  min,
  max,
  label,
}: TimeSpinnerProps) => (
  <div className={`${rowHeight} w-[112px]`}>
    <Input
      value={padWithZero(value)}
      classNames={{ wrapper: cn([rowHeight]) }}
      type="number"
      clearable={false}
      onChange={(event: ChangeEvent<HTMLInputElement>) =>
        onChange(event.target.value)
      }
      onBlur={onBlur}
      rawProps={{
        min,
        max,
        role: 'spinbutton',
        'aria-label': label,
        'aria-valuemin': min,
        'aria-valuemax': max,
        'aria-valuenow': value,
      }}
      trailingElement={
        <SpinnerButtons
          onIncrement={onIncrement}
          onDecrement={onDecrement}
          label={label}
        />
      }
    />
  </div>
);
